(function () {

/*
  jQuery(".footer .inline-menu .expand-sub").click(function() {

    if(jQuery(this).next(".inline-menu--sub").hasClass("inline-menu-active")) {
      jQuery(".footer .inline-menu--sub").removeClass("inline-menu-active").slideUp("fast");
      jQuery(".footer .expand-sub").removeClass("expand-inline-menu");

      return false;
    }

    jQuery(".footer .inline-menu--sub").removeClass("inline-menu-active").slideUp("fast");
    jQuery(".footer .expand-sub").removeClass("expand-inline-menu");

    jQuery(this).next(".inline-menu--sub").addClass("inline-menu-active").slideDown("fast");
    jQuery(this).addClass("expand-inline-menu");
  });
*/
})();
